import React from 'react';
import {connect} from 'react-redux';
import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import {UserConnexionStyles} from '../../../User/components/Connexion/styles';

const style = {
  row: {
    color: 'rgb(142 142 142)',
    fontWeight: 'normal',
  },
};

class DivisionPurchases extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      purchases: undefined,
    };
  }

  getDivisionPurchases = payload => {
    return (_dispatch, getState) => {
      fetch(getEndpoint('getDivisionPurchases', payload.divisionId), {
        method: 'GET',
        headers: getHeaders(getState().authentication),
      })
        .then(response => response.json())
        .then(data => {
          if (data.error) {
            payload.onError && payload.onError();
          } else {
            payload.onSuccess && payload.onSuccess(data);
          }
        });
    };
  };

  componentDidUpdate(prevProps) {
    if (
      (this.props.divisionInfos &&
        prevProps.divisionInfos &&
        prevProps.divisionInfos.id !== this.props.divisionInfos.id) ||
      (prevProps.leagueId &&
        this.props.leagueId &&
        prevProps.leagueId !== this.props.leagueId)
    ) {
      this.setState({
        loading: false,
        purchases: undefined,
      });
    }
  }

  render() {
    const {divisionInfos, dispatch} = this.props;
    if (!divisionInfos) {
      return null;
    }
    const {purchases, loading} = this.state;
    if (!purchases) {
      return loading ? (
        <div style={{marginBottom: 50}}>loading...</div>
      ) : (
        <button
          onClick={() => {
            this.setState({loading: true});
            dispatch(
              this.getDivisionPurchases({
                divisionId: divisionInfos.id,
                onSuccess: ({purchases}) =>
                  this.setState({
                    purchases,
                    loading: false,
                  }),
                onError: () =>
                  this.setState({
                    loading: false,
                  }),
              }),
            );
          }}
          style={{marginBottom: 50}}
          className="btn btn-info">
          Fetch purchases
        </button>
      );
    }
    return (
      <div style={UserConnexionStyles.container}>
        <table className="table table-sm table-responsive table-striped">
          <thead>
            <tr>
              <th>Payment</th>
              <th>Product</th>
              <th>Purchase Date</th>
              <th>Target id</th>
              <th>userId</th>
            </tr>
          </thead>
          <tbody>
            {purchases.map(purchase => (
              <tr>
                <th style={style.row}>{purchase.paymentMethod}</th>
                <th style={style.row}>{purchase.productId}</th>
                <th style={style.row}>{purchase.purchasedAt}</th>
                <th style={style.row}>{purchase.targetId}</th>
                <th style={style.row}>{purchase.userId}</th>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(DivisionPurchases);



// WEBPACK FOOTER //
// ./src/pages/Support/League/Widgets/DivisionPurchases/index.js